import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import { StyledMenuItem } from './StyledComponents/Menu/Menu.tsx';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { StyledFormControl } from "./StyledComponents/Inputs/Inputs.js";
import { useTheme } from "../ThemeContext/ThemeContext.js";

export const IntervalSelect = ({ name, value, callback }) => {
    const { colors } = useTheme();
    const handleChange = (event) => {
        if (callback) {
            callback(event.target.value)
        }
    };

    return (
        <Box sx={{ minWidth: 120, mt: 2, ml: 2 }}>
            <StyledFormControl colors={colors} sx={{ minWidth: 200 }}>
                <InputLabel id="simple-select-label">{name}</InputLabel>
                <Select
                    labelId="simple-select-label"
                    id="simple-select"
                    value={value}
                    label={name}
                    onChange={handleChange}
                >
                    <StyledMenuItem colors={colors}     value={60}>60 seconds</StyledMenuItem>
                    <StyledMenuItem colors={colors} value={300}>5 minutes</StyledMenuItem>
                    <StyledMenuItem colors={colors} value={3600}>1 hour</StyledMenuItem>
                    <StyledMenuItem colors={colors} value={86400}>1 day (24 hours)</StyledMenuItem>
                    <StyledMenuItem colors={colors} value={259200}>3 days</StyledMenuItem>
                    <StyledMenuItem colors={colors} value={432000}>5 days</StyledMenuItem>
                    <StyledMenuItem colors={colors} value={604800}>1 week (7 days)</StyledMenuItem>
                    <StyledMenuItem colors={colors} value={2592000}>1 month (30 days)</StyledMenuItem>
                </Select>
            </StyledFormControl>
        </Box>
    );
}